import React, { Component, useEffect, useState } from "react";
import { PorAsinListTable } from "../porAsinList/PorAsinListTable";
import { AppLayout } from "@amzn/awsui-components-react/polaris";
import { SearchSideBar } from "../searchSideBar/searchSideBar";
import { useSelector } from "react-redux";
import { RootState } from "./rootReducer";
import Tabs from "@amzn/awsui-components-react/polaris/tabs";
import { Notification } from "../notification/notification";
import NoSsr from "./NoSsr";
import "./App.css";
import { AsinValidationTable } from "../validation/asinValidationTable";
import { BaselineTable } from "../dateBaseline/baselineTable";
import {
  addOrUpdateUrlParameter,
  getValueFromUrlParameter,
  TAB_ID_KEY,
} from "../../util/urlUtils";
import { OneClickLaunchTable } from "../oneClickLaunch/oneClickLaunchTable";
import { OclSubmissionTools } from "../oneClickLaunch/oneClickLaunchSubmissionTools";
import { CacheableNotification } from "../notification/cacheableNotification";
import { StamperWizard } from "../stampUtils/StamperWizard";
import { InitializeRum } from "../rum/initializeRum";
import { LoomAgentAssistantWidget } from "../../components/loom-agent-assistant/LoomAgentAssistantWidget";
import { selectIsLoomAgentAssistantEnabled } from "../userInfo/userInfoSlice";

const Content = () => {
  const { isEditing } = useSelector((state: RootState) => state.porAsinList);
  const isLoomAgentAssistantEnabled = useSelector(
    selectIsLoomAgentAssistantEnabled
  );
  const [tab, setTab] = useState("asins");
  const [activeDrawerId, setActiveDrawerId] = useState<string | null>(null);
  const tabIdFromUrl = getValueFromUrlParameter(TAB_ID_KEY, "asins");
  useEffect(() => {
    setTab(tabIdFromUrl);
  }, [tabIdFromUrl]);

  //TODO: Implement proper router after refactoring query href logic
  const stamperView = window.location.href.split("/").slice(-1)[0] == "stamper";

  return (
    <div className="awsui">
      <InitializeRum />
      <AppLayout
        headerSelector={"#mosaic-navigation"}
        footerSelector={"#footer"}
        // navigationOpen={false}
        // the search sidebar depends on state only available in the URL
        navigation={
          <NoSsr>
            <SearchSideBar />
          </NoSsr>
        }
        navigationHide={isEditing || tab === "launch" || stamperView}
        contentType={"table"}
        notifications={
          <div>
            <Notification />
            <CacheableNotification />
          </div>
        }
        stickyNotifications={true}
        navigationWidth={300}
        drawers={[
          ...(isLoomAgentAssistantEnabled
            ? [
                {
                  id: "agent-assistant",
                  ariaLabels: {
                    drawerName: "Loom Agent Assistant",
                    closeButton: "Close Loom Agent Assistant",
                    triggerButton: "Open Loom Agent Assistant",
                    resizeHandle: "Resize Loom Agent Assistant panel",
                  },
                  trigger: { iconName: "gen-ai" as const },
                  resizable: true,
                  defaultSize: 420,
                  content: (
                    <div
                      style={{
                        height: "100%",
                        width: "100%",
                        padding: "10px",
                        boxSizing: "border-box",
                      }}
                    >
                      <LoomAgentAssistantWidget />
                    </div>
                  ),
                },
              ]
            : []),
          ...(tab === "launch" && !stamperView
            ? [
                {
                  id: "submission-history",
                  ariaLabels: {
                    drawerName: "Submission History",
                    closeButton: "Close submission history",
                    triggerButton: "Open submission history",
                    resizeHandle: "Resize submission history panel",
                  },
                  trigger: { iconName: "status-info" as const },
                  resizable: true,
                  defaultSize: 420,
                  content: (
                    <div
                      style={{
                        padding: "10px",
                      }}
                    >
                      <div style={{ height: "100%", width: "100%" }}>
                        <OclSubmissionTools />
                      </div>
                    </div>
                  ),
                },
              ]
            : []),
        ]}
        content={
          <div id={"app-content"}>
            {stamperView ? (
              StamperWizard()
            ) : (
              <Tabs
                activeTabId={tab}
                tabs={[
                  {
                    label: "ASINs",
                    id: "asins",
                    content: <PorAsinListTable />,
                  },
                  {
                    label: "Validation",
                    id: "validation",
                    content: <AsinValidationTable />,
                  },
                  {
                    label: "Baseline",
                    id: "baseline",
                    content: <BaselineTable />,
                  },
                  {
                    label: "Launch",
                    id: "launch",
                    content: <OneClickLaunchTable />,
                  },
                ]}
                onChange={(event) => {
                  const tabId = event.detail.activeTabId;
                  addOrUpdateUrlParameter(TAB_ID_KEY, tabId);
                  setTab(tabId);
                }}
              />
            )}
          </div>
        }
      />
    </div>
  );
};

class App extends Component {
  render() {
    return <Content />;
  }
}

export default App;
